import React from 'react';

const Restaurant = () => {
    return (
        <div>
            Restaurant
        </div>
    );
};

export default Restaurant;
